import React, { useEffect, useState } from 'react';
import './style/common.css';
import './App.css';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router } from 'react-router-dom';
import FrontendAuth from './router/FrontendAuth';
import 'dayjs/locale/zh-cn';
import busEvent from '@/utils/bus';

// import './style/skin/default.css';

function App() {
  const [custom, setCustom] = useState<string>('default');
  const [language, setLanguage] = useState<boolean>(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage === null) {
      return true; // 默认为中文
    }
    return JSON.parse(savedLanguage);
  });

  useEffect(() => {
    const handler = (value: boolean) => {
      setLanguage(value);
    };

    busEvent.on('switchLanguage', handler);

    // 清除事件监听
    return () => {
      busEvent.off('switchLanguage', handler);
    };
  }, []);
  const { t, i18n } = useTranslation(); // t用于翻译，i18n用于切换语言
  const changeLanguage = (lng: string | undefined) => {
    i18n.changeLanguage(lng); // 切换语言
  };

  useEffect(() => {
    changeLanguage(language ? 'zh' : 'en');
  }, [language]);

  useEffect(() => {
    import(`./style/skin/${custom}.css`)
      .then(module => console.log('Loaded theme:', custom))
      .catch(error => console.error('Error loading theme:', error));
  }, [custom]);
  return (
    <div className={custom}>
      <ConfigProvider locale={language ? zhCN : enUS}>
        <Router>
          <FrontendAuth />
        </Router>
      </ConfigProvider>
    </div>
  );
}

export default App;
